import meteor from './meteor/reducers';
import timesheets from './timesheets/reducers';

const rootReducer =  { meteor, timesheets };

export default rootReducer
